import { frFR as coreFR } from "@mui/material/locale";
import { frFR as dateFR } from "@mui/x-date-pickers/locales";
import { frFR as dataFR } from "@mui/x-data-grid/locales";

import { enUS as coreEN } from "@mui/material/locale";
import { enUS as dateEN } from "@mui/x-date-pickers/locales";
import { enUS as dataEN } from "@mui/x-data-grid/locales";

import "moment/locale/fr";

type LanguageConfig = {
  label: string;
  icon: string;
  locales: Array<any>;
};

const Languages: Record<string, LanguageConfig> = {
  fr: {
    label: "Français",
    icon: "/fr.svg",
    locales: [coreFR, dateFR, dataFR],
  },
  en: {
    label: "English",
    icon: "/gb.svg",
    locales: [coreEN, dateEN, dataEN],
  },
};

export default Languages;

export const defaultLanguage = 'fr';